import { trackPackageEvent } from '../api/packageAnalytics';
const packageAnalyticsMiddleware = store => next => action => {
  const before = store.getState();
  const result = next(action);
  try {
    const after = store.getState();
    if (['CART_ADD_ITEM', 'CART_ADD_ITEM_WITH_ADDON'].includes(action.type) && after.cart !== before.cart) {
      const products = Array.isArray(action.product) ? action.product : [action.product];
      const seen = new Set();
      products.forEach(product => {
        if (!product?._id || seen.has(product._id) || !['main', 'custom'].includes(product.pack || action.pack || 'main')) return;
        if (!(after.cart?.items || []).some(item => item.product?._id === product._id || item.id === product._id)) return;
        seen.add(product._id);
        trackPackageEvent('cart', { productId: product._id });
      });
    }
    if (action.type === 'WISHLIST_ADD_ITEM' && after.wishlist !== before.wishlist && (after.wishlist || []).some(item => item._id === action.product?._id) && !(before.wishlist || []).some(item => item._id === action.product?._id)) {
      trackPackageEvent('wishlist', { productId: action.product._id });
    }
  } catch (_) { /* Preserve state changes and the dispatch return value. */ }
  return result;
};
export default packageAnalyticsMiddleware;
